/**
 * Created by Pavel
 */

define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'library/fcse-util/url'
], function($, _, Object, OptionsMixin, EventDispatcher, Url){
    'use strict';

    var AccordionStateHandler = function(param, options) {
        EventDispatcher.apply(this, arguments);

        // Set default options
        var defaultOptions = {
            idField: 'data-hotel-id',
            nodeContentRoute: 'allt_frontend.package.destination.accordion_offers'
        };
        this.addOptions(defaultOptions, options);

        this._param = param;
        this._currentState = null;
        this.registerEvent('changed');
    };

    AccordionStateHandler.prototype = $.extend({}, Object.create(OptionsMixin), Object.create(EventDispatcher.prototype), {
        /**
         * get parameter name
         * @returns string
         */
        getParam: function() {
            return this._param;
        },

        /**
         * get UI state from frontend
         * @returns {Array}
         */
        getUIState: function() {
            return [];
        },

        /**
         * Apply to frontend
         */
        applyState: function(state) {
            /*
            {'gname': '', hid: '', page: '', rpp:'', sort:''}
             */
            this._currentState = state;

            if (!state || this._scrollToHotel(state.hid)) {
                return;
            }

            var contentNode = $('[data-original-group-name="' + state.gname + '"]');
            if (!contentNode.length) {
                return;
            }
            var node = contentNode.closest('[data-fcse-role="accordion--node"]');

            //$('[data-fcse-role="accordion--node--header"]', node).click();
            node.data('node-instance').open();
            contentNode.data('content-node-instance').open({
                sort: state.sort,
                resultsPerPage: state.rpp,
                page: state.page
            });
        },

        /**
         * Content node route request success handler
         * @param data
         * @param requestData
         * @private
         */
        _onRequestSuccess: function(data, requestData) {
            if (requestData && requestData.route == this.option('nodeContentRoute') && this._currentState) {
                setTimeout($.proxy(this._scrollToHotel, this, this._currentState.hid), 300);
            }
        },

        /**
         * Scroll to hotel if found
         * @param hotelId
         * @returns {boolean}
         * @private
         */
        _scrollToHotel: function(hotelId) {
            var element = $('[data-hotel-id="' + hotelId + '"]');

            if (element.length) {
                setTimeout(function() {
                    $(window).scrollTop(element.offset().top - 50);
                }, 1000);

                this._currentState = null;
                return true;
            }
            return false;
        },

        /**
         * Init handlers for all types
         */
        init: function() {
            this.option('requestHandler').on('success', $.proxy(this._onRequestSuccess, this));

            if (typeof history.pushState !== 'undefined') {
                $('body').off('click.acstate').on('click.acstate', '[data-fcse-role="offer-item"]', function(event) {
                    if ($(event.target).is('[data-fcse-distinct-link]') || $(event.target).closest('[data-fcse-distinct-link]').length) {
                        return;
                    }

                    var targetElement = $(event.currentTarget).closest('[data-fcse-role="offer-item"]');
                    var url = targetElement.attr('data-back-button-support');
                    if (url) {
                        var urlObj = new Url(url);
                        history.pushState(urlObj.query, '', url);
                        targetElement.find('[data-fcse-role="hotel-link"]:first').trigger('click', event);
                    }
                });
            }

        },

        /**
         * state change handler
         */
        stateChanged: function() {
            this.dispatchEvent('changed');
        }
    });

    return AccordionStateHandler;
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/accordion/accordionStateHandler.js